import indexedDBHelper from '@/helper/indexedDBHelper';
import { useRootStore } from '@/store/root';
import { useContextLinksStore } from '@/store/contextLinks';

const routes = [
  {
    path: 'search',
    meta: {
      public: false,
    },
    beforeEnter: async (to, from, next) => {
      const { expSearch } = await indexedDBHelper.getData('meta');
      useRootStore().setParentObject({ type: 'search' });

      if (!expSearch) {
        next({ path: `/login` });
      }

      useContextLinksStore().setContextLinks({
        type: 'search',
        contextLinks: expSearch.contextLinks,
      });

      next();
    },
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: ':context?',
        name: 'search',
        component: () => import('@/views/search/Search/Search.vue'),
        children: [
          {
            path: ':id?',
            name: 'segment-search',
          },
        ],
      },
    ],
  },
  {
    name: 'global-search',
    path: 'global-search',
    redirect: 'search',
  },
];

export default routes;
